import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { PathTopic } from '../../data/builders/path_topic_builder';
import { TodoRefreshService } from '../../data/services/todo_refresh_service';
interface ITopic {
  desc: string;
  has_opted_in: boolean;
  id: number;
  name: string;
  nk: string;
  rank: number;
}

export class TopicContainerController {
  private topics: PathTopic[] = [];
  private showValidationAlert: boolean = false;
  private showValidationTheme: string = 'warning';
  private validationMessage: string = 'You have not changed your selections.';
  private trackTopicsModel: {
    initial_topics_by_id: Record<string, PathTopic>;
    updated_topics_by_id: Record<string, PathTopic>;
  } = {
    initial_topics_by_id: {},
    updated_topics_by_id: {}
  };

  constructor(private ngTodoRefreshService: TodoRefreshService, private updateTopicOptInsCommand: ICommand) {}

  $onChanges() {
    this.clearTrackedTopics();
    this.trackTopicsModel.initial_topics_by_id = _4.keyBy(_4.cloneDeep(this.topics), 'id');
  }

  clearTrackedTopics() {
    this.trackTopicsModel = {
      initial_topics_by_id: {},
      updated_topics_by_id: {}
    };
  }

  onSubmitTopics() {
    let updatedTopics: PathTopic[] = [];
    updatedTopics = _4.compact(
      _4.map(this.trackTopicsModel.updated_topics_by_id, (updatedtopic) => {
        const initialTopic = this.trackTopicsModel.initial_topics_by_id[updatedtopic.id];
        if (updatedtopic.has_opted_in !== initialTopic.has_opted_in) {
          return updatedtopic;
        } else {
          return;
        }
      })
    ) as PathTopic[];
    if (updatedTopics.length > 0) {
      this.showValidationAlert = false;
      this.updateTopicOptInsCommand(updatedTopics)
        .then(() => {
          this.showValidationAlert = true;
          this.showValidationTheme = 'success';
          this.validationMessage = 'Topic updates have changed your To-Dos';
          setTimeout(() => {
            this.showValidationAlert = false;
          }, 3000);
          this.ngTodoRefreshService.showWithText('Topic updates have changed your To-Dos');
        })
        .catch((e) => {
          // TODO: Add a message for the user.
        });
    } else {
      this.showValidationTheme = 'warning';
      this.validationMessage = 'You have not changed your selections.';
      this.showValidationAlert = true;
    }
  }
  optInTopic(topic: PathTopic) {
    this.trackTopicsModel.updated_topics_by_id[topic.id] = topic;
  }
}

export class TopicContainerComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-todos/src/components/topic_container/topic_container.html';
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    topics: '<',
    isDisabled: '<'
  };
  public controller: any = TopicContainerController;
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/components/topic_container/topic_container.ts